import useSWR from 'swr'

import { RewardsRoundLeaderboardUser } from '../constants/rewards'

const fetcher = async (): Promise<RewardsRoundLeaderboardUser[]> => {
  const response = await fetch('/api/leaderboard', { cache: 'no-store' })
  const data = await response.json()
  return data.leaderboard
}

export default function useLeaderboard() {
  return useSWR(['Leaderboard'], fetcher, { revalidateOnFocus: false })
}
